/** One record that uses the activity, in the "Where it's used" panel and its relation
 *  drawer: its name — a link to its console page (an orphan day plan has none: plain text) —
 *  then the facts that make an edit or a delete risky (`rowFacts`). */
import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import type { ActivityUsedByRef } from '@/api/activities';

import { rowFacts, rowHref, type WhereUsedGroupKey } from './whereUsedModel';

/** A row's box: one `body2` line (the panel's skeleton rows take the same). */
export const WHERE_USED_ROW_SX = { minWidth: 0, typography: 'body2', overflowWrap: 'anywhere' } as const;

export function WhereUsedRow({ group, row }: { group: WhereUsedGroupKey; row: ActivityUsedByRef }) {
  const href = rowHref(row);
  const name = row.description?.trim() || `#${row.id}`;
  const facts = rowFacts(group, row);
  return (
    <Box
      component="li"
      sx={WHERE_USED_ROW_SX}
      data-where-used-row={`${group}:${row.id}`}
    >
      {href ? (
        <Link
          component={RouterLink}
          to={href}
          underline="hover"
          color="text.primary"
          sx={{ fontWeight: 600 }}
        >
          {name}
        </Link>
      ) : (
        name
      )}
      {facts.length > 0 && (
        <Box component="span" sx={{ color: 'text.secondary' }}>
          {` · ${facts.join(' · ')}`}
        </Box>
      )}
    </Box>
  );
}
